import { render, staticRenderFns } from "./AddSubdomainForm.vue?vue&type=template&id=639f2e63&"
import script from "./AddSubdomainForm.vue?vue&type=script&lang=js&"
export * from "./AddSubdomainForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639f2e63')) {
      api.createRecord('639f2e63', component.options)
    } else {
      api.reload('639f2e63', component.options)
    }
    module.hot.accept("./AddSubdomainForm.vue?vue&type=template&id=639f2e63&", function () {
      api.rerender('639f2e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/SubDomains/AddSubdomainForm.vue"
export default component.exports